/**
 * Datos auxiliares para el formulario de contacto cuando el producto
 * seleccionado es "automotor". No es exhaustivo — usado para pre-rellenar
 * pickers con opciones comunes; cada campo permite "Otro" cuando aplica.
 */

export type EngineType = "nafta" | "diesel" | "electrico" | "hibrido";
export type CoverageType =
  | "responsabilidad-civil"
  | "terceros-completo"
  | "todo-riesgo-franquicia"
  | "todo-riesgo-sin-franquicia";

export const carBrands = [
  "Volkswagen",
  "Toyota",
  "Renault",
  "Ford",
  "Fiat",
  "Chevrolet",
  "Peugeot",
  "Citroën",
  "Nissan",
  "Honda",
  "Hyundai",
  "Kia",
  "Jeep",
  "Mercedes-Benz",
  "BMW",
  "Audi",
  "Otra",
] as const;

/**
 * Modelos populares por marca (Argentina). Se usan como sugerencias en
 * un <datalist> para que el usuario pueda elegir o tipear libre.
 */
export const carModelsByBrand: Record<string, string[]> = {
  Volkswagen: ["Gol", "Polo", "Virtus", "Vento", "Amarok", "T-Cross", "Nivus", "Taos", "Tiguan"],
  Toyota: ["Etios", "Yaris", "Corolla", "Corolla Cross", "Hilux", "SW4", "RAV4"],
  Renault: ["Kwid", "Sandero", "Logan", "Stepway", "Kangoo", "Duster", "Oroch", "Koleos"],
  Ford: ["Ka", "Fiesta", "Focus", "EcoSport", "Ranger", "Territory", "Bronco"],
  Fiat: ["Argo", "Cronos", "Mobi", "Toro", "Strada", "Pulse", "Fastback"],
  Chevrolet: ["Onix", "Onix Plus", "Cruze", "Tracker", "S10", "Spin", "Trailblazer"],
  Peugeot: ["208", "2008", "3008", "5008", "Partner", "Rifter", "Expert"],
  Citroën: ["C3", "C3 Aircross", "C4 Cactus", "C5 Aircross", "Berlingo"],
  Nissan: ["Versa", "Kicks", "Frontier", "X-Trail"],
  Honda: ["Fit", "City", "HR-V", "WR-V", "CR-V"],
  Hyundai: ["HB20", "Creta", "Tucson", "Santa Fe", "Kona"],
  Kia: ["Picanto", "Rio", "Sportage", "Sorento", "Seltos"],
  Jeep: ["Renegade", "Compass", "Cherokee", "Wrangler"],
  "Mercedes-Benz": ["Clase A", "Clase C", "GLA", "GLC", "Sprinter", "Vito"],
  BMW: ["Serie 1", "Serie 3", "X1", "X3", "X5"],
  Audi: ["A1", "A3", "Q2", "Q3", "Q5"],
};

export const carYears = (() => {
  // De 2026 a 1980 (descendente)
  const current = 2026;
  const min = 1980;
  return Array.from({ length: current - min + 1 }, (_, i) => current - i);
})();

export const engineTypes: Array<{ value: EngineType; label: string }> = [
  { value: "nafta", label: "Nafta" },
  { value: "diesel", label: "Diésel" },
  { value: "hibrido", label: "Híbrido" },
  { value: "electrico", label: "Eléctrico" },
];

export const coverageTypes: Array<{
  value: CoverageType;
  label: string;
  hint: string;
}> = [
  {
    value: "responsabilidad-civil",
    label: "Responsabilidad Civil",
    hint: "Cobertura básica obligatoria — solo daños a terceros.",
  },
  {
    value: "terceros-completo",
    label: "Terceros completo",
    hint: "RC + incendio + robo total. Sin daños propios.",
  },
  {
    value: "todo-riesgo-franquicia",
    label: "Todo riesgo con franquicia",
    hint: "Cobertura completa con un deducible por evento.",
  },
  {
    value: "todo-riesgo-sin-franquicia",
    label: "Todo riesgo sin franquicia",
    hint: "Máxima cobertura, sin deducible.",
  },
];
